import { render, staticRenderFns } from "./CancelReasons.vue?vue&type=template&id=4f795a9b&scoped=true&"
import script from "./CancelReasons.vue?vue&type=script&lang=js&"
export * from "./CancelReasons.vue?vue&type=script&lang=js&"
import style0 from "./CancelReasons.vue?vue&type=style&index=0&id=4f795a9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f795a9b",
  null
  
)

export default component.exports